import React from 'react'
import { Container } from 'react-bootstrap';
import OwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';

export const Blog = () => {

    const options = {
        dots: false,
        autoplayTimeout: 5000, 
        autoplaySpeed: 1000,
        autoplay: true,
        responsive: {
            0: {
                items: 1.2,
            },
            400: {
                items: 1.3,
            },
            600: {
                items: 1.5,
            },
            700: {
                items: 2,
            },
            1000: {
                items: 2.2,
    
            }
        },
    };

    const BlogList = [
        {
            blogImg: '/assets/images/blog_1.png',
            blogTitle: 'The Future of Web Development: Trends to Watch in 2025 ',
            blogBtn: 'Read More',
            path: '/blog-detail'
        },
        {
            blogImg: '/assets/images/blog_2.png',
            blogTitle: 'Why Cross-Platform Mobile Apps Are the Future ',
            blogBtn: 'Read More',
            path: '/blog-warehouse'
        },
        {
            blogImg: '/assets/images/blog_3.png',
            blogTitle: 'The Importance of UI/UX in Modern Software ',
            blogBtn: 'Read More',
            path: '/blog-growth'
        },
        {
            blogImg: '/assets/images/blog_4.png',
            blogTitle: 'How Custom Software Development Empowers Businesses ',
            blogBtn: 'Read More',
            path: '/blog-soft'
        }
    ]

  return (
    <section className='blog_section'>
        <Container>
            <h5 className='service-text' data-aos="fade-right" data-aos-duration="3000">Our Blogs</h5>

            <div className='blog-flex line-2-dot'>
                <div data-aos="fade-right" data-aos-duration="3000">
                <h4>Unlock Your Business Potential Elevate to the Next Level</h4>
                </div>
            </div>
        </Container>

        <div className='offset-margin blog-margin'>
            <OwlCarousel className='owl-theme blog-carousel position-relative' loop margin={20} nav items="2.2" {...options}>
                {
                    BlogList.map((blogCard,index)=>(
                        <div key={index} className='item'>
                            <Link to={blogCard.path}>
                                <div className='blog-card'>
                                    <div className='blog-img'>
                                        <img src={blogCard.blogImg} alt="Blog-Image" />
                                    </div>
                                    <div className='blog-body'>
                                        <h3>{blogCard.blogTitle}</h3>
                                        <button className='read-more'>{blogCard.blogBtn}</button>
                                    </div>
                                </div>
                            
                            </Link>
                        </div>
                    ))
                }
            </OwlCarousel>
        </div>
    </section>
  )
}
